import React from 'react'
import { useState } from 'react'
import { Box } from '@mui/system'
import HeroBanner from '../components/HeroBanner'
import SearchExercises from '../components/SearchExercises'
import Exercises from '../components/Exercises'

const Home = () => {
  const [exercises, setExercises] = useState([]);
  const [bodyPart, setBodyPart] = useState('all')

  return (
    <Box>
      <HeroBanner />
      <SearchExercises 
        setExercises={setExercises} 
        setBodyPart={setBodyPart}
        bodyPart={bodyPart}
      />
      <Exercises 
        setExercises={setExercises} 
        exercises={exercises}
        bodyPart={bodyPart}
      />
    </Box>
  )
}

export default Home